<template>
  <div class="contai_h">
    <div class="ce">
      <div class="con_query">
        <Query @child-event="emitToparent" message="民品"></Query>
      </div>

      <div class="cont_header">
        <div class="cont_o">
          <h2>今日新增：{{ xzlength }}</h2>
          <h3>典当金额：{{ xzpri }}元</h3>
        </div>

        <div class="cont_o">
          <h2>在当订单：{{ ilength }}</h2>
          <h3>典当金额：{{ zpri }}元</h3>
        </div>
      </div>
    </div>

    <div class="cont_tabs">
      <div class="ces">
        <span class="black" @click="getzdata">正常存当业务</span>
        <span class="blues" @click="blueClick">今日到期业务</span>
        <span class="blue" @click="greenClick">今日新增业务</span>
        <span class="yus" @click="yusClick">超期业务</span>
        <span class="jus" @click="redClick">超期五天业务</span>
      </div>
      <el-table
        :data="items"
        height="840"
        border
        style="width: 100%"
        :row-class-name="tableRowClassName"
        class="color_text"
        v-loading="loading"
        element-loading-text="任务正在执行请等待..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              @click="handlexu(scope.row._id, scope.row.ticketnumber)"
              type="primary"
              circle
              size="small"
              class="btn_xu"
              >续</el-button
            >
            <el-button
              @click="handleClick(scope.row._id)"
              type="primary"
              circle
              size="small"
              class="btn_xu"
              >查</el-button
            >
            <!-- <el-button @click="setPnumber(scope.row._id)" type="text" size="small"
              >续当</el-button
            > -->

            <el-button
              @click="handleshu(scope.row._id)"
              type="primary"
              circle
              size="small"
              class="btn_xu"
              >赎</el-button
            >

            <el-button @click="has(scope.row._id)" type="text" size="small" class="btn_xu"
              >打票</el-button
            >

            <el-button
              @click="UpLoading(scope.row)"
              type="text"
              size="small"
              class="btn_xu"
              >上传</el-button
            >

            <el-button
              @click="CreateText(scope.row)"
              size="small"
              class="btn_xu"
              type="text"
              >提醒模板</el-button
            >
            <el-button
              @click="PrintText(scope.row)"
              size="small"
              class="btn_xu"
              type="text"
              >打印告知书</el-button
            >

            <el-button
              v-if="shows"
              @click="ceDs(scope.row.cardnumber, scope.row)"
              type="text"
              size="small"
              class="btn_xu"
            >
              <el-tooltip :content="'上次发送时间：' + sendtime" placement="top-start">
                <span @mouseover="mouseover(scope.row.ticketnumber)">微信通知</span>
              </el-tooltip>
            </el-button>

            <!-- <el-button
              @click="xuTemplate('ot6pe5cMagF59URlzBimGw0OVm9k')"
              size="small"
              class="btn_xu"
              type="text"
              >测试发通知</el-button
            > -->

            <el-button
              v-if="shows"
              @click="sendSms(scope.row, scope.row.ticketnumber)"
              type="text"
              size="small"
              class="btn_xu"
            >
              <el-tooltip :content="'上次发送时间：' + sendsmstime" placement="top-start">
                <span @mouseover="mousesms(scope.row.ticketnumber)">发送短信</span>
              </el-tooltip>
            </el-button>

            <!-- <el-button
              v-if="shows"
              @click="UploadRecord(scope.row)"
              size="small"
              class="btn_xu"
              type="text"
           
              >上传录音</el-button
            > -->
          </template>
        </el-table-column>
        <el-table-column
          prop="deta"
          label="建当日期"
          width="160"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ticketnumber"
          label="票号"
          width="130"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          width="80"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="telnumber"
          label="电话"
          width="130"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column prop="address" label="当户证件地址" width="250">
        </el-table-column> -->

        <!-- <el-table-column prop="itemname" label="类型" width="100"></el-table-column> -->
        <el-table-column
          prop="objname"
          label="物品名字"
          width="150"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="number"
          label="数量"
          width="60"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="weight"
          label="重量/g"
          width="80"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="startdate"
          label="开始日期"
          width="120"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="enddate"
          label="结束日期"
          width="120"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="days"
          label="典当天数"
          width="90"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="cost"
          label="典当综合费"
          width="110"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="上交所单价"
          width="100"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.realpricea !== undefined ? scope.row.realpricea : "未接入" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="rate"
          label="折当率"
          width="100"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.rate == undefined ? "100%" : scope.row.rate + "%" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="unitpricea"
          label="典当单价"
          width="100"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{
              scope.row.unitpricea !== undefined
                ? scope.row.unitpricea
                : (scope.row.price / scope.row.weight).toFixed(0)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="price"
          label="典当金额"
          width="100"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="compre"
          label="是否已缴第一期综合费"
          width="110"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="agent"
          label="开票"
          width="100"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="review"
          label="复核"
          width="100"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="finance"
          label="财务"
          width="100"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="remit"
          label="批款人"
          width="100"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="cardnumber"
          label="证件号"
          width="200"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="address"
          label="证件地址"
          width="200"
          header-align="center"
          align="center"
        >
        </el-table-column>
      </el-table>

      <div class="footer">
        <div>
          <!-- 分页 -->
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="paging"
            :total="yelength"
            :page-size="100"
            class="fs"
          >
          </el-pagination>
          <!-- 分页结束 -->
        </div>
        <div style="margin: 0 20px">
          <!--    //分页导出表格-->
          <download-excel
            class="export-excel-wrapper"
            :data="items"
            :fields="json_fields"
            name="在当业务明细表.xls"
          >
            <el-button type="primary" size="small">分页导出EXCEL</el-button>
          </download-excel>
        </div>

        <el-button type="primary" size="small" @click="GetAllData">ALL</el-button>

        <!-- 全部数据导出表格 -->
        <div style="margin: 0 20px">
          <!--    //导出表格-->
          <download-excel
            class="export-excel-wrapper"
            :data="allItems"
            :fields="json_fields"
            name="全部在当业务明细表.xls"
          >
            <el-button type="primary" size="small" @click="getAll"
              >全部在当导出EXCEL</el-button
            >
          </download-excel>
        </div>
      </div>

      <!-- 续当弹窗 -->
      <el-dialog
        title="续当操作"
        :visible.sync="dialogFormVisible"
        width="50%"
        v-if="dialogFormVisible"
      >
        <el-form :model="form">
          <el-form-item label="当户姓名：" :label-width="formLabelWidth">
            {{ xudata.name }}
          </el-form-item>
          <el-form-item label="票号：" :label-width="formLabelWidth">
            {{ xudata.ticketnumber }}
          </el-form-item>
          <el-form-item label="典当状态：" :label-width="formLabelWidth">
            {{ xstas === true ? "逾期" : "在当" }}
          </el-form-item>
          <el-form-item label="原到期日期：" :label-width="formLabelWidth">
            {{ xudata.enddate }}
          </el-form-item>
          <el-form-item label="典当金额：" :label-width="formLabelWidth">
            {{ xudata.price + "元" }}
          </el-form-item>
          <el-form-item label="选择续当日期：" :label-width="formLabelWidth">
            <div class="block">
              <el-date-picker
                v-model="datevalue"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                @change="days"
              >
              </el-date-picker>
              /** 手动选择当期外的日期时，综合费和利息需要自行计算，小数采用四舍五入**/
            </div>
          </el-form-item>
          <el-form-item label="续当周期：" :label-width="formLabelWidth">
            <div class="cons_o">
              <el-button-group>
                <!-- <el-button type="primary" @click="five(xudata.enddate)" :disabled="true"
                  >5天</el-button
                > -->
                <el-button type="primary" @click="seven(xudata.enddate)" :disabled="xstas"
                  >15天</el-button
                >
                <el-button type="primary" @click="thfive(xudata.enddate)">30天</el-button>
                <el-button
                  type="primary"
                  @click="twufive(xudata.enddate)"
                  :disabled="xstas"
                  >60天</el-button
                >
                <!-- <el-button type="primary" @click="thre(xudata.enddate)">30天</el-button> -->
              </el-button-group>
            </div>
          </el-form-item>
          <el-form-item label="选择的续当天数：" :label-width="formLabelWidth">
            {{ xzdate + "天" }}
          </el-form-item>
          <el-form-item label="续当综合费：" :label-width="formLabelWidth">
            <el-input
              clearable
              v-model="form.pris"
              autocomplete="off"
              class="cont_input"
            ></el-input>
            <span>（本金*会员费率/非会员费率）</span>
          </el-form-item>
          <el-form-item label="上期典当利息：" :label-width="formLabelWidth">
            <el-input
              clearable
              v-model="lx"
              autocomplete="off"
              class="cont_input"
            ></el-input>
            <span
              >（本金*典当利息）起始日期：{{ computDate(xudata.enddate, isLx) }}-{{
                xudata.enddate
              }}</span
            >
          </el-form-item>
          <el-form-item label="上期续当天数：" :label-width="formLabelWidth">
            {{ isLx + "天" }}
          </el-form-item>
          <el-form-item label="逾期天数：" :label-width="formLabelWidth" v-if="xstas">
            {{ ytdy }} 天
          </el-form-item>
          <el-form-item label="续当操作人：" :label-width="formLabelWidth">
            {{ name }}
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormqux">取 消</el-button>
          <el-button type="primary" @click="dialogFormend">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 弹窗设置结束测试 -->

      <!-- 打票 -->
      <el-dialog title="打票" :visible.sync="dialogFormVisible1" width="50%">
        <div id="print">
          <table width="100%">
            <tr>
              <!-- <th>典当行</th> -->
              <td rowspan="2" width="8%"></td>
              <td width="12%"></td>
              <td width="33%">
                {{ $store.state.name }}
              </td>
              <td width="15%"></td>
              <td id="32%">
                {{ $store.state.tel }}
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                {{ $store.state.address }}
              </td>
              <td></td>
              <td>
                {{ $store.state.licence }}
              </td>
            </tr>
            <tr>
              <td rowspan="3"></td>
              <td></td>
              <td>{{ xudata.name }}</td>
              <td></td>
              <td>{{ xudata.telnumber }}</td>
            </tr>
            <tr>
              <td></td>
              <td>{{ xudata.address }}</td>
              <td></td>
              <td>{{ xudata.name }}</td>
            </tr>
            <tr>
              <td></td>
              <td>{{ xudata.type }}</td>
              <td></td>
              <td>{{ xudata.cardnumber }}</td>
            </tr>
          </table>
          <!-- 物品栏 -->

          <table width="100%">
            <tr>
              <td colspan="7"></td>
            </tr>
            <!-- <tr>
              <td colspan="7"></td>
            </tr> -->
            <tr>
              <td width="8%">1</td>
              <td width="15%">{{ xudata.objname }}</td>
              <td width="27%">
                {{ xudata.speci
                }}{{
                  xudata.weig !== "" && xudata.weig !== undefined
                    ? "，" + xudata.weig + "g"
                    : ""
                }}
              </td>
              <td width="5%">{{ xudata.num }}</td>
              <td width="10%">{{ xudata.pric }}</td>
              <!-- <td width="5%">{{ rate }}</td> -->
              <td width="5%">100%</td>
              <td width="26%">
                <div class="sum_pri">
                  <span v-for="item in xudata.pric" :key="item.id">{{ item }}</span>
                  <span>0</span>
                  <span>0</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                {{ xudata.objnamea == "" || xudata.objnamea == undefined ? "" : "2" }}
              </td>
              <td>{{ xudata.objnamea }}</td>
              <td>
                {{ xudata.specia
                }}{{
                  xudata.weiga !== "" && xudata.weiga !== undefined
                    ? "，" + xudata.weiga + "g"
                    : ""
                }}
              </td>
              <td>{{ xudata.numa }}</td>
              <td>{{ xudata.prica }}</td>
              <td>{{ xudata.ratea }}</td>

              <td>
                <div class="sum_pri">
                  <span v-for="item in xudata.prica" :key="item.id">{{ item }}</span>
                  <span v-if="xudata.prica">0</span>
                  <span v-if="xudata.prica">0</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                {{ xudata.objnameaa == "" || xudata.objnameaa == undefined ? "" : "3" }}
              </td>
              <td>{{ xudata.objnameaa }}</td>
              <td>
                {{ xudata.speciaa
                }}{{
                  xudata.weigaa !== "" && xudata.weigaa !== undefined
                    ? "，" + xudata.weigaa + "g"
                    : ""
                }}
              </td>
              <td>{{ xudata.numaa }}</td>
              <td>{{ xudata.pricaa }}</td>
              <td>{{ xudata.rateaa }}</td>
              <td>
                <div class="sum_pri">
                  <span v-for="item in xudata.pricaa" :key="item.id">{{ item }}</span>
                  <span v-if="xudata.pricaa">0</span>
                  <span v-if="xudata.pricaa">0</span>
                </div>
              </td>
            </tr>
          </table>
          <table width="100%">
            <tr>
              <td width="20%"></td>
              <td width="25%">{{ prices }}</td>
              <td width="10%"></td>
              <td width="18%"></td>
              <td width="28%">
                <div class="sum_pri">
                  <span v-for="item in priceNums" :key="item.id">{{ item }}</span>
                  <span>0</span>
                  <span>0</span>
                </div>
              </td>
            </tr>
            <tr>
              <td width="20%"></td>
              <td width="25%">{{ costs }}</td>
              <td width="10%"></td>
              <td width="13%">{{ xudata.cost }}</td>
              <td width="28%">
                <div class="sum_pribox">
                  <span>{{ xudata.yfl }}</span>
                  <span>{{ xudata.yll }}</span>
                </div>
              </td>
              <!-- <td width="10%">{{ xudata.yll }}</td> -->
            </tr>
            <tr>
              <td width="20%"></td>
              <td width="25%">{{ priceA }}</td>
              <td width="10%"></td>
              <td width="13%">{{ Number(xudata.price) - Number(xudata.cost) }}</td>
              <td width="13%"></td>
              <td width="10%"></td>
            </tr>
          </table>
          <table width="100%">
            <tr>
              <td width="12%"></td>
              <td width="7%">{{ n }}</td>
              <td width="5%">{{ y }}</td>
              <td width="5%">{{ r }}</td>
              <td width="7%"></td>
              <td width="7%">{{ ns }}</td>
              <td width="5%">{{ ys }}</td>
              <td width="5%">{{ rs }}</td>
              <td width="40%"></td>
            </tr>
          </table>
          <table width="100%">
            <tr>
              <td width="5%"></td>
              <td width="40%">
                补充约定：逾期续当/赎当须按月费率4.2%结付当期综合费并且典当月利率0.28%不免收（15/60天当期，按时赎/续当，该当期内的利息可免收），逾期不足5日按5日额外计费。
              </td>
              <td width="30%"></td>
            </tr>
            <tr>
              <td width="5%"></td>
              <td width="40%"></td>
              <td width="30%"></td>
            </tr>
          </table>
          <table width="100%">
            <tr>
              <td width="5%"></td>
              <td width="12%"></td>
              <td width="15%"></td>
              <td width="4%"></td>
              <td width="10%"></td>
              <td width="13%"></td>
              <td width="5%">{{ jn }}</td>
              <td width="5%">{{ jy }}</td>
              <td width="5%">{{ jr }}</td>
              <td width="5%"></td>
            </tr>
          </table>
        </div>

        <!-- 底部按钮 -->
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" v-print="'#print'">确定打票</el-button>
        </div>
      </el-dialog>

      <!-- 赎回弹窗 -->
      <el-dialog
        title="赎回操作："
        :visible.sync="dialogVshus"
        width="50%"
        :before-close="dialogVshusOff"
      >
        <div class="ctens" v-for="item in sitems" :key="item._id">
          <span>典当状态：{{ xstas === true ? "逾期" : "在当" }}</span>
          <span>当户：{{ item.name }}</span>
          <span>票号：{{ item.ticketnumber }}</span>
          <span>物品名称：{{ item.objname }}</span>
          <span v-if="xstas">逾期天数：{{ ytdy + "天" }}</span>
          <span>典当金额：{{ item.price + "元" }}</span>
          <span>上期典当天数：{{ lastDay + "天" }}</span>
          <span>典当综合费（不足5天按5天收取0.7%）：{{ xupri + "元" }}</span>
          <span>典当利息（不足5天按5天收取0.05%）：{{ yqlx + "元" }}</span>
          <span>上期典当利息（按上期典当天数收取）：{{ wflx + "元" }}</span>
          <span>
            手续费：<el-input
              placeholder="请输入手续费"
              v-model="sxf"
              clearable
              style="width: 20%"
            />
            元
          </span>

          <!-- <span v-if="xstas">逾期罚息：{{ pena + '元'}}</span>    v-if="xstas"-->
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVshusOff">取 消</el-button>
          <el-button type="primary" @click="shuEnd(sitems)">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 上传凭证弹窗 -->

      <el-dialog
        title="上传凭证"
        :visible.sync="dialogUploading"
        width="45%"
        :before-close="dialogUploadingClose"
      >
        <span style="margin: 10px 0">上传当票：</span>
        <!-- 上传当票： -->

        <el-upload
          v-if="dpIsshow"
          class="upload-demo"
          action="#"
          :http-request="uploads"
          :on-preview="handlePreview"
          :data="{ isName: 'dp' }"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="1"
          :on-exceed="handleExceed"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <!-- <i>点击上传</i> -->
        </el-upload>

        <sapn class="watchPiao" v-else>
          <el-button size="small" type="primary" @click="WacthdP">{{
            isSHowImg == true ? "关闭" : "查看"
          }}</el-button>
          <el-button size="small" type="primary" @click="UploadWatch" class="upload_xg"
            >修改</el-button
          >
        </sapn>

        <span v-if="isSHowImg">
          <img :src="pzImg" alt="" width="100%" />
        </span>

        <div>
          <span>上传续当凭证：</span>
          <!-- 上传续当凭证 -->

          <el-upload
            class="upload-demo"
            action="#"
            :http-request="uploads"
            :on-preview="handlePreview"
            :data="{ isName: 'pz' }"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
          >
            <el-button size="small" type="primary">修改</el-button>
            <!-- <i>点击上传</i> -->
          </el-upload>

          <div style="margin: 10px 0">
            <el-button size="small" type="primary" @click="ViewPz">{{
              pzIsShows == true ? "关闭" : "查看凭证"
            }}</el-button>
          </div>

          <div v-if="pzIsShows">
            <img :src="pzImgs" alt="" width="100%" />
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogUploadingClose">取 消</el-button>
          <el-button type="primary" @click="dialogUploadings()">确 定</el-button>
        </span>
        <span>
          <!-- <img :src="{{}}" alt=""> -->
        </span>
      </el-dialog>

      <!-- 生成通知模板文本 -->
      <el-dialog
        title="通知模板"
        :visible.sync="dialogText"
        width="50%"
        :before-close="handleCloseText"
      >
        <DialogTextDetail
          :TextData="DialogTextData"
          :Titles="this.userData.title"
          :lastDate="this.newArray"
          v-if="dialogText"
        ></DialogTextDetail>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleCloseText">关 闭</el-button>
        </span>
      </el-dialog>

      <!-- 待处理弹窗 -->
      <el-dialog
        title="待办通知"
        :visible.sync="dialogBacklog"
        width="20%"
        :before-close="handleCloseBacklog"
      >
        今日有
        <span style="color: red; font-weight: bold; font-size: 20px">{{
          BacklogData
        }}</span>
        笔 绝当 待处理业务，请及时前往处理
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleCloseBacklog">关 闭</el-button>
        </span>
      </el-dialog>

      <!-- 请求全部数据进度弹窗 -->
      <el-dialog :visible.sync="dialogGetAll" width="15%" :before-close="removeAllData">
        <div class="dialogs_fd">
          <span>
            <el-progress
              type="circle"
              :percentage="AllDataIndex"
              width="80"
            ></el-progress>
          </span>
          <span>正在请求全部数据 - 已请求{{ AllDataIndex + "%" }}</span>
        </div>
      </el-dialog>

      <el-dialog
        title="打印典当告知书"
        :visible.sync="PrintTextDiglog"
        width="50%"
        :before-close="PrintTextDiglogClose"
      >
        <PrintNotification :NewDatas="NewDatas" />
        <!-- <PrintDiglog :NewDatas="NewDatas"/> -->
      </el-dialog>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import Query from "@/components/Query";
// import util from "@/components/util";
import PrintNotification from "@/components/printNotification/PrintNotification";
import DialogTextDetail from "@/components/dialogText/DialogTextDetail";
const COS = require("cos-js-sdk-v5");
const cos = new COS({
  SecretId: "AKID1pOghRu62i7G8j36sOddMoztXv2tUord", // 身份识别ID
  SecretKey: "YjdHfndCUVGjwta091cwzmIXVBbkcEag", // 身份秘钥
});

export default {
  name: "whens",
  data() {
    return {
      ACCESS_TOKEN: "", //ACCESS_TOKEN
      deta: "", //今天的日期
      items: [], //拿到在当的所有数据
      dpri: "-", //数据看板统计出总的典当综合费
      price: "", //计算出在当的总金额
      id: "", //被点击续当的数据id

      dialogFormVisible: false, //默认不打开续当弹窗
      dialogFormVisible1: false, //默认不打开打票弹窗
      dialogVshus: false, //默认不打开赎当弹窗
      dialogUploading: false, //上传凭证弹窗开关
      formLabelWidth: "150px",
      form: {
        pris: 0, //典当综合费
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },

      datevalue: "", // 选择的续当日期
      xudata: "", //被点击续当的数据
      day: "", //逾期绝当定义日期
      token: "", //token
      name: "", //获取当前登录用户的名字
      xdate: "", //续当后的总典当天数
      xzdate: 0, //选择的续当天数
      ydays: "", //原来的典当天数
      ypris: "", //原来的典当金额
      zonpri: "", //计算好的总典当综合费

      ilength: 0, //在当数据总数量
      xzlength: 0, //今日新增的数量
      xzpri: 0, //新增典当金额
      yelength: 0, //页码的总数
      // itemss: "", //每页的数据

      shows: false, //通知按钮/默认关闭

      n: "",
      y: "",
      r: "",
      ns: "",
      ys: "",
      rs: "",

      jn: "",
      jy: "",
      jr: "",

      rate: "100%", //默认折当率
      prices: "", //典当金额大写
      priceA: "", //实付大写
      costs: "", //综合费大写
      // sfpri:"",   //实付金额大写
      // sfpr:0,     //实付金额小写

      sendtime: "", //推送时间
      sendsmstime: "", //短信推送时间
      xstas: false, //被点击的业务是否逾期
      ytdy: 0, //逾期天数

      pena: 0, //逾期罚息
      lx: 0, //典当利息
      rece: 0, //实收

      // newdates: "", //续当开始日期

      sitems: "", //被点击的赎当数据
      xupri: 0, //逾期综合息费

      zpri: 0, //典当总金额
      zpriClick: 0, //计算完时，典当总金额

      yspri: 0, //应收

      totalarray: [], //在当订单总金额 多次请求返回的数组

      priceNums: "", //

      titles: "", //当前典当行名字

      wfzhf: 0, //上期未付综合费
      yqlx: 0, //逾期利息
      wflx: 0, //上期未付利息

      dp: "", //需要上传的当票
      pz: "", //需要上传的凭证

      pzid: "", //凭证id

      dpIsshow: true, //上传当票 按钮默认打开
      isSHowImg: false, //当票图片开关

      pzIsShows: false, //上传凭证图片默认关闭
      dialogText: false, //关闭生成文档
      dialogBacklog: false, //待办弹窗

      pzImg: "", //票图片

      DialogTextData: {}, //通知文本内容弹窗

      userData: "",

      newArray: "", //上一期的续当时间

      BacklogData: 0, // 待办数据

      // excel
      json_fields: {
        建当日期: "deta", //常规字段
        票号: "ticketnumber",
        姓名: "name",
        电话: "telnumber",
        物品名称: "objname",
        数量: "number",
        "重量/g": "weight",
        开始日期: "startdate",
        结束日期: "enddate",
        "上交所单价/元": "realpricea",
        "折当率/%": "rate",
        "典当单价/元": "unitpricea",
        "典当金额/元": "price",
        月费率: "yfl",
        月利率: "yll",
        经办人: "agent",
        复核: "review",
        财务: "finance",
      },

      json_meta: [
        [
          {
            " key ": " charset ",
            " value ": " utf- 8 ",
          },
        ],
      ],
      allItems: [], //要导出的全部在当数据

      dialogGetAll: false,
      AllDataIndex: 0,

      isLx: 0, // 当前续当的业务上期续当是否为30天，true == 是30天， false == 不是30天
      PrintTextDiglog: false, //打印当物来源告知书

      NewDatas: {}, //打印告知书要传输的数据

      loading: false, //loading

      lastDay: 0, //上期典当天数
      sxf: 0, //手续费
    };
  },

  components: {
    Query,
    DialogTextDetail,
    PrintNotification,
    // PrintDiglog
  },

  methods: {
    has(event) {
      this.id = event;
      //请求该条数据的信息
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("add_data").doc("' + event + '").get()',
        })
        .then((refs) => {
          refs.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          if (refs.data.data[0].rate !== undefined) {
            this.rate = refs.data.data[0].rate;
          }
          this.xudata = refs.data.data[0]; //被点击的全部数据
          this.dialogFormVisible1 = !this.dialogFormVisible1;
          this.n = dayjs(refs.data.data[0].startdate).year();
          this.y = dayjs(this.xudata.startdate).month() + 1;
          this.r = dayjs(this.xudata.startdate).date();
          this.ns = dayjs(refs.data.data[0].enddate).year();
          this.ys = dayjs(refs.data.data[0].enddate).month() + 1;
          this.rs = dayjs(refs.data.data[0].enddate).date();

          this.jn = dayjs(refs.data.data[0].deta).year();
          this.jy = dayjs(refs.data.data[0].deta).month() + 1;
          this.jr = dayjs(refs.data.data[0].deta).date();

          this.prices = this.digitUppercase(refs.data.data[0].price);
          this.costs = this.digitUppercase(refs.data.data[0].cost);
          this.priceA = this.digitUppercase(
            Number(refs.data.data[0].price) - Number(refs.data.data[0].cost)
          );

          //  let priceNums = refs.data.data[0].price.forEach(item=>{
          //    item.
          //  })
          this.priceNums = refs.data.data[0].price;
          // for( let item of refs.data.data[0].price){
          //   console.log(item)
          //   this.priceNums = item
          // }
          // this.sfpri = this.digitUppercase(Number(refs.data.data[0].price) - Number(refs.data.data[0].cost))
          // this.sfpr = Number(refs.data.data[0].price) - Number(refs.data.data[0].cost)
        });
    },

    days(e) {
      //如果输入框里没有值，则将选择的续当天数改成0
      if (e == null) {
        return (this.xzdate = 0), (this.form.pris = 0), (this.lx = 0), (this.pena = 0);
      }
      // 当手动选择日期时，触发 拿到当前选择的日期减去开始日期，得到的总典当天数
      this.xdate = dayjs(e).diff(dayjs(this.xudata.startdate), "day");
      //当手动选择日期时，触发，拿到手动选择日期的天数
      this.xzdate = dayjs(e).diff(dayjs(this.xudata.enddate), "day");
      this.form.pris = 0;
      this.pena = 0;
      (this.lx = 0), (this.yspri = "手动选日期无法计算应收");
    },
    // 查看订单
    handleClick(e) {
      let id = e;
      this.$router.push({ path: "/details", query: { id: id } });
    },
    // 筛选逾期/快绝当的订单
    tableRowClassName({ row }) {
      if (row.enddate > this.day && row.enddate < this.deta) {
        return "success-row";
      }
      //今日最后一天
      if (row.enddate == this.day) {
        return "warning-row";
      }
      //今日新增业务
      if (row.reviewdate == this.deta) {
        return "today-row";
      }
      //今日到期业务
      if (row.enddate == this.deta) {
        return "tod-row";
      }

      return "";
    },

    //续当成功执行的事件
    yover() {
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").add({data:{name:"${
            this.xudata.name
          }",xuday:"${this.deta}",cardnumber:"${this.xudata.cardnumber}",itemname:"${
            this.xudata.objname
          }",weight:"${this.xudata.weight}",
            ticketnumber:"${this.xudata.ticketnumber}",telnumber:"${
            this.xudata.telnumber
          }",startdate:"${this.xudata.startdate}",xupri:"${this.form.pris}",
            enddate:"${this.datevalue}",dday:"${this.xzdate}",xuname:"${
            this.name
          }",overdate:"${dayjs(this.xudata.enddate)
            .add(1, "day")
            .format("YYYY-MM-DD")}",ytdy:"${this.ytdy}",pena:"${this.pena}",rece:"${
            this.rece
          }",yspri:"${this.yspri}",stas:"续当",pri:"${this.xudata.price}",lx:"${
            this.lx
          }",couqons:"线下不适用",couqonmoney:"0",xnumber:"",time:"${dayjs().format(
            "HH:mm"
          )}",cardnumber:"${this.xudata.cardnumber}",agent:"${
            this.xudata.agent
          }",review:"${this.xudata.review}",finance:""}})`,
        })
        .then((rcc) => {
          if (rcc.data.errcode == 0) {
            setTimeout(() => {
              this.$router.go(0);
            }, 1500);
          }
        });
    },
    //赎当成功执行的事件
    sover() {
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").add({data:{name:"${
            this.sitems[0].name
          }",xuday:"${this.deta}",itemname:"${this.sitems[0].objname}",weight:"${
            this.sitems[0].weight
          }",ticketnumber:"${this.sitems[0].ticketnumber}",
          telnumber:"${this.sitems[0].telnumber}",startdate:"${
            this.sitems[0].startdate
          }",xupri:"${this.xupri}",enddate:"${this.sitems[0].enddate}",dday:"0",xuname:"${
            this.name
          }",overdate:"${this.sitems[0].startdate}",ytdy:"${this.ytdy}",pena:"${
            this.pena
          }",rece:"${this.rece + this.yqlx + this.wflx + Number(this.sxf)}",yspri:"${
            this.rece + this.yqlx + this.wflx + Number(this.sxf)
          }",stas:"赎当",pri:"${this.sitems[0].price}",lx:"${this.yqlx}",lastlx:"${
            this.wflx
          }", wechatexpend:"${
            this.sxf
          }",couqons:"线下不适用",couqonmoney:"0",time:"${dayjs().format(
            "HH:mm"
          )}",cardnumber:"${this.sitems[0].cardnumber}",agent:"${
            this.sitems[0].agent
          }",review:"${this.sitems[0].review}",finance:""}})`,
        })
        .then((sc) => {
          if (sc.data.errcode == 0) {
            setTimeout(() => {
              this.$router.go(0);
            }, 1500);
          }
        });
    },

    //点击取消续当的事件
    dialogFormqux() {
      (this.dialogFormVisible = false),
        (this.datevalue = ""),
        (this.xdate = ""),
        (this.xzdate = 0),
        (this.form.pris = 0),
        (this.pena = 0),
        (this.lx = 0),
        (this.yspri = 0);
      this.isLx = 0;
    },
    //点击确认续当事件
    dialogFormend() {
      //如果输入框的值为空，不可续当
      if (this.form.pris == 0) {
        return this.$message.error("典当综合费不能为空哦");
      }
      //总的已付典当综合服务费金额
      this.zonpri = Math.round(
        Number(this.ypris) + Number(this.form.pris) + Number(this.lx)
      );
      this.rece = Number(this.form.pris) + Number(this.lx); //实收

      if (this.xstas == true) {
        // 逾期 点击确定续当执行的方法
        setTimeout(() => {
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:
                'db.collection("add_data").doc("' +
                this.id +
                '").update({data:{enddate:"' +
                this.datevalue +
                '",days:"' +
                this.xdate +
                '",cost:"' +
                this.zonpri +
                '"}})',
            })
            .then((rec) => {
              // 续当开始日期
              // this.newdates = dayjs(this.xudata.enddate)
              //   .add(1, "day")
              //   .format("YYYY-MM-DD");
              if (rec.data.errcode === 0) {
                this.$notify({
                  title: "续当成功",
                  message: "恭喜你，该订单已续当成功",
                  type: "success",
                });
                this.sendtui();
                //续当成功执行的方法
                this.yover();

                //打印小票
                // util.print(
                //   "逾期续当",
                //   this.xudata,
                //   this.xzdate,
                //   this.rece,
                //   dayjs(this.xudata.enddate).add(1, "day").format("YYYY-MM-DD"),
                //   this.datevalue,
                //   this.name,
                //   dayjs().format("YYYYMMDDddddHHmmss")
                // );
              } else {
                this.$notify({
                  title: "续当失败",
                  message: "请刷新页面在操作或检查输入的信息是否有误",
                  type: "warning",
                });
                setTimeout(() => {
                  this.$router.go(0);
                }, 1500);
              }
            });
        }, 800);
      } else {
        //正常续当点击  确定续当执行的方法
        setTimeout(() => {
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:
                'db.collection("add_data").doc("' +
                this.id +
                '").update({data:{enddate:"' +
                this.datevalue +
                '",days:"' +
                this.xdate +
                '",cost:"' +
                this.zonpri +
                '"}})',
            })
            .then((rec) => {
              // 续当开始日期
              // this.newdates = dayjs(this.xudata.enddate)
              //   .add(1, "day")
              //   .format("YYYY-MM-DD");

              if (rec.data.errcode === 0) {
                this.$notify({
                  title: "续当成功",
                  message: "恭喜你，该订单已续当成功",
                  type: "success",
                });
                //打印小票
                // util.print(
                //   "续当",
                //   this.xudata,
                //   this.xzdate,
                //   this.rece,
                //   dayjs(this.xudata.enddate).add(1, "day").format("YYYY-MM-DD"),
                //   this.datevalue,
                //   this.name,
                //   dayjs().format("YYYYMMDDddddHHmmss")
                // );
                this.sendtui();
                //续当成功执行的方法
                this.yover();
              } else {
                this.$notify({
                  title: "续当失败",
                  message: "请刷新页面在操作或检查输入的信息是否有误",
                  type: "warning",
                });
                setTimeout(() => {
                  this.$router.go(0);
                }, 1500);
              }
            });
        }, 800);
      }
    },

    //阿拉伯数字转大写

    digitUppercase(n) {
      let fraction = ["角", "分"];
      let digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
      let unit = [
        ["元", "万", "亿"],
        ["", "拾", "佰", "仟"],
      ];
      let head = n < 0 ? "欠" : "";
      n = Math.abs(n);
      let s = "";
      for (let i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(
          /零./,
          ""
        );
      }
      s = s || "整";
      n = Math.floor(n);
      for (let i = 0; i < unit[0].length && n > 0; i++) {
        let p = "";
        for (let j = 0; j < unit[1].length && n > 0; j++) {
          p = digit[n % 10] + unit[1][j] + p;
          n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
      }
      return (
        head +
        s
          .replace(/(零.)*零元/, "元")
          .replace(/(零.)+/g, "零")
          .replace(/^整$/, "零元整")
      );
    },

    //续当成功给当户发推送
    sendtui() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("user2020zl").where({idcard:"${this.xudata.cardnumber}"}).get()`,
        })
        .then((ruser) => {
          ruser.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          //请求微信公众号的信息

          this.xuTemplate(ruser.data.data[0]._openid);
        });
    },
    xuTemplate(openid) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("weTemplate").where({}).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          this.axios
            .post(
              "/api/cgi-bin/message/wxopen/template/uniform_send?access_token=" +
                this.ACCESS_TOKEN,
              {
                touser: openid,
                mp_template_msg: {
                  appid: res.data.data[0].mpappid,
                  template_id: res.data.data[0].xdTemplate,
                  url: "http://weixin.qq.com",
                  miniprogram: {
                    appid: res.data.data[0].xcxappid,
                    pagepath: "pages/offline/offlines/index",
                  },
                  data: {
                    first: {
                      value: `尊敬的${this.xudata.name}先生/女士，您以下当票已续费成功，系统稍后打印续当凭证。`,
                      color: "#173177",
                    },
                    keyword1: {
                      value: this.xudata.ticketnumber,
                      color: "#173177",
                    },
                    keyword2: {
                      value: this.xudata.objname,
                      color: "#173177",
                    },
                    keyword3: {
                      value: this.xzdate + "天",
                      color: "#173177",
                    },
                    keyword4: {
                      value: this.datevalue,
                      color: "#173177",
                    },
                    remark: {
                      value:
                        "逾期续当按月费率4.2%续费，逾期赎当须按4.2%补足上一当期综合费利息，另逾期不足5天按5天收未付综合费。",
                      color: "#173177",
                    },
                  },
                },
              }
            )
            .then((re) => {
              console.log(re);
            });
        });

      //发公众号x续当成功模板消息
      // this.axios
      //   .post(
      //     "/api/cgi-bin/message/wxopen/template/uniform_send?access_token=" +
      //       this.ACCESS_TOKEN,
      //     {
      //       touser: openid,
      //       mp_template_msg: {
      //         appid: "wx9019ccce538953c5",
      //         template_id: "v65L746RHEAzGT1n39gxSfKAM5ZwOvrVywFDeETvcmo",
      //         url: "http://weixin.qq.com",
      //         miniprogram: {
      //           appid: "wx153c354afba9df6f",
      //           pagepath: "pages/offline/offlines/index",
      //         },
      //         data: {
      //           first: {
      //             value: `尊敬的${this.xudata.name}先生/女士，您以下当票已续费成功，系统稍后打印续当凭证。`,
      //             color: "#173177",
      //           },
      //           keyword1: {
      //             value: this.xudata.ticketnumber,
      //             color: "#173177",
      //           },
      //           keyword2: {
      //             value: this.xudata.objname,
      //             color: "#173177",
      //           },
      //           keyword3: {
      //             value: this.xzdate + "天",
      //             color: "#173177",
      //           },
      //           keyword4: {
      //             value: this.datevalue,
      //             color: "#173177",
      //           },
      //           remark: {
      //             value:
      //               "逾期续当按月费率4.2%续费，逾期赎当须按4.2%补足上一当期综合费利息，另逾期不足5天按5天收未付综合费。",
      //             color: "#173177",
      //           },
      //         },
      //       },
      //     }
      //   )
      //   .then((r) => {
      //     console.log(r);
      //   });
    },
    //点击续当操作
    handlexu(event, pnumber) {
      this.id = event;
      //请求该条数据的信息
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("add_data").doc("' + this.id + '").get()',
        })
        .then((refs) => {
          refs.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.xudata = refs.data.data[0]; //被点击的全部数据
          this.ydays = refs.data.data[0].days; //被点击的数据的典当天数
          this.ypris = refs.data.data[0].cost; //被点击的数据的往期典当综合费
          //判断是否支付第一期综合费
          if (!("compre" in refs.data.data[0]) || refs.data.data[0].compre == "是") {
            //
            this.dialogFormVisible = !this.dialogFormVisible;
            //判断是否为逾期
            if (refs.data.data[0].enddate < this.deta) {
              return (
                (this.xstas = true),
                (this.ytdy = dayjs(this.deta).diff(
                  dayjs(refs.data.data[0].enddate),
                  "day"
                ))
              );
            }
            this.xstas = false;
          } else {
            this.$alert(
              "该当户未支付第一期典当综合费，不可续当，请提醒当户支付综合费后，才可续赎当操作",
              "温馨提示",
              {
                confirmButtonText: "确定",
              }
            );
          }
          //请求上期典当是否为30天
          this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("yxus_record").where({ticketnumber:"${pnumber}"}).limit(1000).get()`,
            })
            .then((resList) => {
              resList.data.data.forEach((element, index, array) => {
                array[index] = JSON.parse(element);
              });
              this.isLx = Number(resList.data.data[resList.data.data.length - 1].dday);
            });
        });
    },
    //点击5天的时候
    five(edate) {
      (this.datevalue = dayjs(edate).add(5, "day").format("YYYY-MM-DD")), //到期日期栏
        (this.xdate = Number(this.ydays) + Number(5)), //累计的典当天数
        (this.xzdate = "5"); //续当天数

      if (this.xstas == true) {
        //逾期
        return (
          (this.form.pris = Math.trunc(this.xudata.price * 0.007)), //逾期综合费
          (this.lx = Math.trunc(this.xudata.price * 0.0005)), //逾期利息
          (this.yspri =
            Number(Math.trunc(this.xudata.price * 0.007)) +
            Number(Math.trunc(this.xudata.price * 0.0005))) //应收
        );
      }
      //未逾期
      this.form.pris = Math.trunc(this.xudata.price * 0.007); //典当综合费
      (this.lx = Math.trunc(this.xudata.price * 0.0005)), //典当利息
        (this.yspri =
          Number(Math.trunc(this.xudata.price * 0.007)) +
          Number(Math.trunc(this.xudata.price * 0.0005)));
    },
    //点击15天的时候
    seven(edate) {
      (this.datevalue = dayjs(edate).add(15, "day").format("YYYY-MM-DD")), //到期日期栏
        (this.xdate = Number(this.ydays) + Number(15)), //累计的典当天数
        (this.xzdate = "15"); //续当天数
      // if (this.xstas == true) {
      //   //逾期
      //   return (
      //     (this.form.pris = Math.trunc(this.xudata.price * 0.0098)), //逾期综合费
      //     (this.lx = Math.trunc(this.xudata.price * 0.0002)), //逾期利息
      //     (this.yspri =
      //       Number(Math.trunc(this.xudata.price * 0.0098)) +
      //       Number(Math.trunc(this.xudata.price * 0.0002))) //应收
      //   );
      // }

      //未逾期
      this.form.pris = Math.trunc(this.xudata.price * 0.0189); //典当综合费
      this.isLx == 30
        ? (this.lx = Math.trunc(this.xudata.price * 0.0015))
        : (this.lx = 0), // 典当利息
        // (this.lx = Math.trunc(this.xudata.price * 0.0002)), //典当利息
        (this.yspri =
          Number(Math.trunc(this.xudata.price * 0.0189)) +
          Number(
            this.isLx == 30
              ? (this.lx = Math.trunc(this.xudata.price * 0.003))
              : (this.lx = 0)
          ));
    },
    //点击30天的时候
    thfive(edate) {
      (this.datevalue = dayjs(edate).add(30, "day").format("YYYY-MM-DD")),
        (this.xdate = Number(this.ydays) + Number(30)),
        (this.xzdate = "30");
      if (this.xstas == true) {
        //逾期
        return (
          (this.form.pris = Math.trunc(this.xudata.price * 0.042)), //逾期典当综合费
          (this.lx = Math.trunc(this.xudata.price * 0.0001 * this.isLx)), //逾期利息
          (this.yspri =
            Number(Math.trunc(this.xudata.price * 0.042)) +
            Number(Math.trunc(this.xudata.price * 0.0001 * this.isLx)))
        );
      }
      //未逾期
      this.form.pris = Math.trunc(this.xudata.price * 0.025); //典当综合费
      (this.lx = this.xudata.price * 0.003), //利息
        (this.yspri =
          Number(Math.trunc(this.xudata.price * 0.025)) +
          Number(this.xudata.price * 0.003));
    },
    //点击60天的时候
    twufive(edate) {
      (this.datevalue = dayjs(edate).add(60, "day").format("YYYY-MM-DD")),
        (this.xdate = Number(this.ydays) + Number(60)),
        (this.xzdate = "60");
      // if (this.xstas == true) {
      //   return (
      //     (this.form.pris = Math.trunc(this.xudata.price * 0.035)), //逾期典当综合费
      //     (this.lx = Math.trunc(this.xudata.price * 0.0025)), //逾期利息
      //     (this.yspri =
      //       Number(Math.trunc(this.xudata.price * 0.035)) +
      //       Number(Math.trunc(this.xudata.price * 0.0025)))
      //   );
      // }
      //未逾期
      this.form.pris = Math.trunc(this.xudata.price * 0.04); //典当综合费
      this.isLx == 30 ? (this.lx = Math.trunc(this.xudata.price * 0.003)) : (this.lx = 0),
        (this.yspri = Math.trunc(this.xudata.price * 0.04));
    },
    //点击30天的时候
    thre(edate) {
      (this.datevalue = dayjs(edate).add(30, "day").format("YYYY-MM-DD")),
        (this.xdate = Number(this.ydays) + Number(30)),
        (this.xzdate = "30");
      if (this.xstas == true) {
        //逾期
        return (
          (this.form.pris = Math.trunc(this.xudata.price * 0.042)), //逾期典当综合费
          (this.lx = Math.trunc(this.xudata.price * 0.003)), //逾期利息
          (this.yspri =
            Number(Math.trunc(this.xudata.price * 0.042)) +
            Number(Math.trunc(this.xudata.price * 0.003))) //应收
        );
      }
      //未逾期
      this.form.pris = Math.trunc(this.xudata.price * 0.024); //典当综合费
      (this.lx = 0), (this.yspri = Math.trunc(this.xudata.price * 0.024));
    },
    //赎回执行的事件函数

    //赎回操作
    handleshu(e) {
      this.id = e;
      //通过id查找到该数据
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("add_data").doc("${this.id}").get()`,
        })
        .then((refs) => {
          refs.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
            this.sitems = refs.data.data;
          });
          // 判断是否支付第一期典当综合费
          if (!("compre" in refs.data.data[0]) || refs.data.data[0].compre == "是") {
            this.dialogVshus = !this.dialogVshus;
            //判断是否逾期赎回
            if (refs.data.data[0].enddate < this.deta) {
              (this.xstas = true),
                (this.ytdy = dayjs(this.deta).diff(
                  dayjs(refs.data.data[0].enddate),
                  "day"
                )),
                // (this.pena = Math.round(refs.data.data[0].price * 0.0075)),  //逾期罚息
                (this.xupri = Math.trunc(refs.data.data[0].price * 0.007)), //逾期综合息费
                (this.rece = Math.trunc(
                  Number(refs.data.data[0].price) +
                    Number(Math.trunc(refs.data.data[0].price * 0.007)) //本金+与逾期那几天的综合费，不足5天按5天收取
                ));

              //上期未付综合费
              this.getLastDay(refs.data.data[0].ticketnumber, true);
              // this.wflx = Math.trunc(refs.data.data[0].price * 0.0028);
              this.yqlx = Math.trunc(refs.data.data[0].price * 0.0005);
              //利息

              //上期未付利息
            } else {
              this.xstas = false;
              this.rece = Math.trunc(Number(this.sitems[0].price));
              this.getLastDay(refs.data.data[0].ticketnumber, false);
            }
          } else {
            this.$alert(
              "该当户未支付第一期典当综合费，不可续当，请提醒当户支付综合费后，才可续赎当操作",
              "温馨提示",
              {
                confirmButtonText: "确定",
              }
            );
          }
        });
    },
    //赎回确定按钮
    shuEnd() {
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").doc("' +
            this.id +
            '").update({data:{state:"赎回"}})',
        })
        .then((re) => {
          if (re.data.errcode == 0) {
            this.sover(),
              this.$message({
                type: "success",
                message: "赎回成功",
              });
            setTimeout(() => {
              this.$router.go(0);
            }, 1500);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    //关闭赎当操作
    dialogVshusOff() {
      (this.dialogVshus = false), (this.yqlx = 0), (this.wflx = 0), (this.sitems = "");
      this.xupri = 0;
    },

    //拿到上期典当的典当天数
    getLastDay(event, isYq) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").where({ticketnumber:"${event}"}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          // console.log(res.data.data[res.data.data.length-1].dday)

          //拿到上次续当的天数
          // return res.data.data[res.data.data.length-1].dday,
          let day = res.data.data[res.data.data.length - 1].dday;
          this.lastDay = res.data.data[res.data.data.length - 1].dday;

          if (isYq) {
            //如是逾期则使用月利息0.3% / 30 = 0.0001 乘以上期实际典当天数
            this.wflx = Math.trunc(0.0001 * day);
          } else {
            //未逾期则使用判断上期是是否等于30天，是则收取
            if (day == 30) {
              this.wflx = Math.trunc(
                res.data.data[res.data.data.length - 1].pri * 0.0028
              );
            } else {
              this.wflx = 0;
            }
          }
        });
    },

    //接收子组件传来的数据
    emitToparent(data, day, shows) {
      let zdata = data.filter(function (product) {
        return product.enddate >= day && product.review != "" && product.state == "在当";
      });

      //循环计算新增典当的总金额
      let str = "";
      for (let i in zdata) {
        str += zdata[i].price;
        str += "+";
      }
      str = str.substring(0, str.length - 1);
      this.zpri = eval(str);

      this.ilength = zdata.length;
      this.items = zdata;

      if (shows == true) {
        return (this.shows = true);
      }
      this.shows = false;
    },

    // 点击分页
    paging(e) {
      let ae = e - 1;
      let pags = ae * 100;
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").where({state:"在当",enddate:_.gte("' +
            this.day +
            '"),whether:true}).limit(100).skip(' +
            pags +
            ").get()",
        })
        .then((paging) => {
          paging.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.items = paging.data.data.reverse();
        });
    },

    //点击蓝色字体筛选
    blueClick() {
      this.shows = true;
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").where({state:"在当",whether:true,enddate:_.eq("' +
            this.deta +
            '")}).limit(1000).get()',
        })
        .then((buledata) => {
          buledata.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.items = buledata.data.data; //点击蓝色筛选的数据
          this.ilength = buledata.data.pager.Total; //点击蓝色请求数量

          //循环计算新增典当的总金额
          let str = "";
          for (let i in buledata.data.data) {
            str += buledata.data.data[i].price;
            str += "+";
          }
          str = str.substring(0, str.length - 1);
          this.zpri = eval(str);
        });
    },
    //点击绿色字体筛选
    greenClick() {
      this.shows = false;
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").where({state:"在当",enddate:_.gte("' +
            this.day +
            '"),whether:true,reviewdate:_.eq("' +
            this.deta +
            '")}).limit(1000).get()',
        })
        .then((grdata) => {
          grdata.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          this.items = grdata.data.data; //筛选的数据
          this.ilength = grdata.data.pager.Total; //数量

          //循环计算新增典当的总金额
          let str = "";
          for (let i in grdata.data.data) {
            str += grdata.data.data[i].price;
            str += "+";
          }
          str = str.substring(0, str.length - 1);
          this.zpri = eval(str);
        });
    },
    //点击黄色字体筛选
    yusClick() {
      this.shows = true;
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").where({state:"在当",enddate:_.gt("' +
            this.day +
            '").and(_.lt("' +
            this.deta +
            '")),whether:true}).limit(1000).get()',
        })
        .then((grdata) => {
          grdata.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.items = grdata.data.data;
          this.ilength = grdata.data.pager.Total; //数量

          //循环计算新增典当的总金额
          let str = "";
          for (let i in grdata.data.data) {
            str += grdata.data.data[i].price;
            str += "+";
          }
          str = str.substring(0, str.length - 1);
          this.zpri = eval(str);
        });
    },
    //点击红色字体筛选
    redClick() {
      this.shows = true;
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").where({state:"在当",enddate:_.eq("' +
            this.day +
            '"),whether:true,}).limit(1000).get()',
        })
        .then((redata) => {
          redata.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.items = redata.data.data;
          this.ilength = redata.data.pager.Total; //数量

          //循环计算新增典当的总金额
          let str = "";
          for (let i in redata.data.data) {
            str += redata.data.data[i].price;
            str += "+";
          }
          str = str.substring(0, str.length - 1);
          this.zpri = eval(str) || 0;
        });
    },
    //点击紫色字体筛选
    zxsClick() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").where({xuday:_.eq("${this.deta}")}).limit(1000).get()`,
        })
        .then((re) => {
          re.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
        });
    },
    //发推送
    ceDs(e, datas) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("user2020zl").where({idcard:"${e}"}).get()`,
        })
        .then((ruser) => {
          ruser.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          if (ruser.data.data[0] == undefined) {
            this.$alert("该当户没有注册会员，请提醒当户注册会员", {
              confirmButtonText: "确定",
            });
          } else {
            this.sendTemplate(ruser.data.data[0].unionid, datas);

            // this.testGetGzhToken()
          }
        });
    },

    //发微信模板消息
    sendTemplate(uid, datas) {
      this.loading = true;
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("weTemplate").where({}).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("openids").where({unionid:"${uid}"}).get()`,
            })
            .then((ra) => {
              ra.data.data.forEach((element, index, array) => {
                array[index] = JSON.parse(element);
              });

              if (ra.data.data.length !== 0) {
                this.GetGzhToken(res, datas, ra.data.data[0].openid);
                //第一个参数，公众号发送模板id信息，

                //第三个参数，该业务数据
                //第四个参数，用户公众的openid
              } else {
                this.loading = false;

                const h = this.$createElement;

                this.$notify({
                  title: "发送失败",
                  message: h(
                    "i",
                    { style: "color: teal" },
                    `未查询到客户: ${datas.name} 的有效openid，请让客户重新关注微信公众号`
                  ),
                });
              }
            });

          // this.getUid(uid, datas, res.data.data);
        });
    },

    GetGzhToken(getParam, datas, openid) {
      this.axios
        .get("/getToken/GetTokenGZH", {
          params: {
            id: getParam.data.data[0].gzhTokenID,
            appid: getParam.data.data[0].mpappid,
            secret: getParam.data.data[0].secret,
          },
        })
        .then((response) => {
          if (response.status == 200) {
            this.getUid(getParam, datas, response.data[0].AccessToken, openid);
            //第一个参数，公众号发送模板id信息，

            //第三个参数，该业务数据
            //第四个参数，发公众号的token
            //第五个参数，用户公众号的openid
            return;
          }
          this.$notify({
            title: "警告",
            message: "token过期，请刷新页面再试",
            type: "warning",
          });
        });
    },

    //去客户查找客户资料拿到uid,通过uid拿到公众号的openid
    getUid(getParam, datas, token, openid) {
      //通过uid去查询用户公众号openid

      //逾期时发的模板
      if (datas.enddate > this.day && datas.enddate < this.deta) {
        let yq = dayjs().diff(dayjs(datas.enddate), "day");

        //发公众号模板消息
        this.axios
          .post("/api/cgi-bin/message/template/send?access_token=" + token, {
            touser: openid,
            // mp_template_msg: {
            appid: getParam.data.data[0].mpappid,
            template_id: getParam.data.data[0].yqTemplate,
            url: "http://weixin.qq.com",
            miniprogram: {
              appid: getParam.data.data[0].xcxappid,
              pagepath: "pages/offline/offlines/index",
            },
            data: {
              first: {
                value: `尊敬的${datas.name}先生/女士，以下当票已经逾期，逾期续/赎当我行按标准费率4.2%/月计费，逾期5天视为绝当，请尽快办理`,
                color: "#173177",
              },
              keyword1: {
                value: datas.ticketnumber,
                color: "#173177",
              },
              keyword2: {
                value: datas.objname,
                color: "#173177",
              },
              keyword3: {
                value: datas.enddate,
                color: "#173177",
              },
              keyword4: {
                value: yq + "天",
                color: "#173177",
              },
              remark: {
                value:
                  "当期不足5天按5天计收综合费利息，逾期续当，上一期典当利息不免收,逾期第5天当户不续当也不赎当，即为绝当，本行将按有关规定处理绝当物品。",
                color: "#173177",
              },
            },
            // },
          })
          .then((r) => {
            console.log("发送返回值", r);
            //添加发送时间，先判断是否有发送过，如果没有，直接往数据库里添加，如果有发送过，再次点击时更新数据
            this.axios
              .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query: `db.collection("sendtimes").where({piaos:"${datas.ticketnumber}"}).get()`,
              })
              .then((ee) => {
                ee.data.data.forEach((element, index, array) => {
                  array[index] = JSON.parse(element);
                });
                //如果不等于0表示，已经有了数据，则更新数据
                if (ee.data.data.length !== 0) {
                  return this.axios.post(
                    "/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN,
                    {
                      env: `${this.userData.env}`,
                      query: `db.collection("sendtimes").doc("${
                        ee.data.data[0]._id
                      }").update({data:{sendtime:"${dayjs().format(
                        "YYYY-MM-DD HH:mm:ss"
                      )}"}})`,
                    }
                  );
                }
                //否则就是添加过数据，添加数据
                this.axios.post(
                  "/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN,
                  {
                    env: `${this.userData.env}`,
                    query: `db.collection("sendtimes").add({data:{sendtime:"${dayjs().format(
                      "YYYY-MM-DD HH:mm:ss"
                    )}",piaos:"${datas.ticketnumber}"}})`,
                  }
                );
              });

            this.loading = false;

            //弹窗提示
            this.$notify({
              title: "发送成功",
              message: "微信通知发送成功",
              type: "success",
            });
          });
      } else if (datas.enddate == this.deta) {
        //今日到期发的模板
        this.axios
          .post("/api/cgi-bin/message/template/send?access_token=" + token, {
            touser: openid,
            // mp_template_msg: {
            appid: getParam.data.data[0].mpappid,
            template_id: getParam.data.data[0].dqTemplate,
            url: "http://weixin.qq.com",
            miniprogram: {
              appid: getParam.data.data[0].xcxappid,
              pagepath: "pages/offline/offlines/index",
            },
            data: {
              first: {
                value: `尊敬的${datas.name}先生/女士，您的当票即将到期，请在到期日前完成续费（仍可享受低至5.5折优惠费率），超期续当不享受优惠费率，按最高标准月费率4.2%续费，敬请留意。`,
                color: "#173177",
              },
              keyword1: {
                value: datas.ticketnumber,
                color: "#173177",
              },
              keyword2: {
                value: datas.objname,
                color: "#173177",
              },
              keyword3: {
                value: datas.price,
                color: "#173177",
              },
              keyword4: {
                value: datas.enddate,
                color: "#173177",
              },
              remark: {
                value:
                  "逾期5天内赎当的，不足5天按5天收取逾期典当综合费用,逾期续当，上一期典当利息不免收。",
                color: "#173177",
              },
            },
            // },
          })
          .then(() => {
            //添加发送时间，先判断是否有发送过，如果没有，直接往数据库里添加，如果有发送过，再次点击时更新数据
            this.axios
              .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query: `db.collection("sendtimes").where({piaos:"${datas.ticketnumber}"}).get()`,
              })
              .then((ee) => {
                ee.data.data.forEach((element, index, array) => {
                  array[index] = JSON.parse(element);
                });
                //如果不等于0表示，已经有了数据，则更新数据
                if (ee.data.data.length !== 0) {
                  return this.axios.post(
                    "/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN,
                    {
                      env: `${this.userData.env}`,
                      query: `db.collection("sendtimes").doc("${
                        ee.data.data[0]._id
                      }").update({data:{sendtime:"${dayjs().format(
                        "YYYY-MM-DD HH:mm:ss"
                      )}"}})`,
                    }
                  );
                }
                //否则就是添加过数据，添加数据
                this.axios.post(
                  "/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN,
                  {
                    env: `${this.userData.env}`,
                    query: `db.collection("sendtimes").add({data:{sendtime:"${dayjs().format(
                      "YYYY-MM-DD HH:mm:ss"
                    )}",piaos:"${datas.ticketnumber}"}})`,
                  }
                );
              });

            this.loading = false;

            //发推送
            this.$notify({
              title: "发送成功",
              message: "微信通知发送成功",
              type: "success",
            });
          });
      } else if (datas.enddate == this.day) {
        //逾期最后一天发的模板通知
        let yq = dayjs().diff(dayjs(datas.enddate), "day");
        //发公众号模板消息
        this.axios
          .post("/api/cgi-bin/message/template/send?access_token=" + token, {
            touser: openid,
            // mp_template_msg: {
            appid: getParam.data.data[0].mpappid,
            template_id: getParam.data.data[0].dqTemplate,
            url: "http://weixin.qq.com",
            miniprogram: {
              appid: getParam.data.data[0].xcxappid,
              pagepath: "pages/offline/offlines/index",
            },
            data: {
              first: {
                value: `尊敬的${datas.name}先生/女士，您的当票已逾期${yq}天，既不续当也不赎当，将为绝当`,
                color: "#173177",
              },
              keyword1: {
                value: datas.ticketnumber,
                color: "#173177",
              },
              keyword2: {
                value: datas.objname,
                color: "#173177",
              },
              keyword3: {
                value: datas.enddate,
                color: "#173177",
              },
              keyword4: {
                value: yq + "天",
                color: "#173177",
              },
              remark: {
                value: "本当票已无法在线续赎，请联系人工客服。联系电话：0769-85323232",
                color: "#173177",
              },
            },
            // },
          })
          .then(() => {
            //添加发送时间，先判断是否有发送过，如果没有，直接往数据库里添加，如果有发送过，再次点击时更新数据
            this.axios
              .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query: `db.collection("sendtimes").where({piaos:"${datas.ticketnumber}"}).get()`,
              })
              .then((ee) => {
                ee.data.data.forEach((element, index, array) => {
                  array[index] = JSON.parse(element);
                });
                //如果不等于0表示，已经有了数据，则更新数据
                if (ee.data.data.length !== 0) {
                  return this.axios.post(
                    "/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN,
                    {
                      env: `${this.userData.env}`,
                      query: `db.collection("sendtimes").doc("${
                        ee.data.data[0]._id
                      }").update({data:{sendtime:"${dayjs().format(
                        "YYYY-MM-DD HH:mm:ss"
                      )}"}})`,
                    }
                  );
                }
                //否则就是添加过数据，添加数据
                this.axios.post(
                  "/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN,
                  {
                    env: `${this.userData.env}`,
                    query: `db.collection("sendtimes").add({data:{sendtime:"${dayjs().format(
                      "YYYY-MM-DD HH:mm:ss"
                    )}",piaos:"${datas.ticketnumber}"}})`,
                  }
                );
              });

            this.loading = false;

            //发送成功通知
            this.$notify({
              title: "发送成功",
              message: "微信通知发送成功",
              type: "success",
            });
          });
      } else {
        //即将到期发的模板
        this.axios
          .post("/api/cgi-bin/message/template/send?access_token=" + token, {
            touser: openid,
            // mp_template_msg: {
            appid: getParam.data.data[0].mpappid,
            template_id: getParam.data.data[0].dqTemplate,
            url: "http://weixin.qq.com",
            miniprogram: {
              appid: getParam.data.data[0].xcxappid,
              pagepath: "pages/offline/offlines/index",
            },
            data: {
              first: {
                value: `尊敬的${datas.name}先生/女士，您的典当业务将在${datas.enddate}到期，请在到期日前完成续当/赎当，逾期按最高月费率4.2% 计费且上一期典当利息不予免收。`,
                color: "#173177",
              },
              keyword1: {
                value: datas.ticketnumber,
                color: "#173177",
              },
              keyword2: {
                value: datas.objname,
                color: "#173177",
              },
              keyword3: {
                value: datas.price,
                color: "#173177",
              },
              keyword4: {
                value: datas.enddate,
                color: "#173177",
              },
              remark: {
                value:
                  "到期前续当仍适用会员费率，逾期续当按4.2%/月计费且上一期典当利息按0.3%/月收费。",
                color: "#173177",
              },
            },
            // },
          })
          .then((r) => {
            console.log("发送返回值", r);
            //添加发送时间，先判断是否有发送过，如果没有，直接往数据库里添加，如果有发送过，再次点击时更新数据
            this.axios
              .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query: `db.collection("sendtimes").where({piaos:"${datas.ticketnumber}"}).get()`,
              })
              .then((ee) => {
                ee.data.data.forEach((element, index, array) => {
                  array[index] = JSON.parse(element);
                });
                //如果不等于0表示，已经有了数据，则更新数据
                if (ee.data.data.length !== 0) {
                  return this.axios.post(
                    "/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN,
                    {
                      env: `${this.userData.env}`,
                      query: `db.collection("sendtimes").doc("${
                        ee.data.data[0]._id
                      }").update({data:{sendtime:"${dayjs().format(
                        "YYYY-MM-DD HH:mm:ss"
                      )}"}})`,
                    }
                  );
                }
                //否则就是添加过数据，添加数据
                this.axios.post(
                  "/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN,
                  {
                    env: `${this.userData.env}`,
                    query: `db.collection("sendtimes").add({data:{sendtime:"${dayjs().format(
                      "YYYY-MM-DD HH:mm:ss"
                    )}",piaos:"${datas.ticketnumber}"}})`,
                  }
                );
              });

            this.loading = false;

            //发推送
            this.$notify({
              title: "发送成功",
              message: "微信通知发送成功",
              type: "success",
            });
          });
      }
    },

    //请求发送推送的时间
    mouseover(e) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("sendtimes").where({piaos:"${e}"}).get()`,
        })
        .then((es) => {
          es.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          if (es.data.data.length == 0) {
            return (this.sendtime = "无记录");
          }
          this.sendtime = es.data.data[0].sendtime;
        });
    },
    //请求短信发送时间
    mousesms(event) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("sendsms").where({piaos:"${event}"}).get()`,
        })
        .then((es) => {
          es.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          if (es.data.data.length == 0) {
            return (this.sendsmstime = "无记录");
          }
          this.sendsmstime = es.data.data[0].sendtime;
        });
    },

    //请求数据
    getzdata() {
      //分页请求 默认第一页
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").where({state:"在当",enddate:_.gte("' +
            this.day +
            '"),whether:true}).limit(100).get()',
        })
        .then((paging) => {
          paging.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.ilength = paging.data.pager.Total;
          this.zpri = this.zpriClick;
          this.items = paging.data.data.reverse();
        });
    },

    //发短信通知
    sendSms(event, pnum) {
      //请求短信模板id
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("smsTemplate").where({name:"${this.titles}"}).get()`,
        })
        .then((ee) => {
          ee.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          // console.log(ee);
          if (ee.data.errcode == 0) {
            this.sendConfirmSms(event, pnum, ee.data.data[0]);
          }
        });
    },
    //正式发送短信
    sendConfirmSms(event, pnum, smsevent) {
      this.axios
        .post("/send", {
          // params: {
          signName: smsevent.signName,
          templateId: smsevent.templateId,
          tel: event.telnumber,
          name: event.name,
          number: event.ticketnumber,
          date: event.enddate,
          price: event.price,
          // },
        })
        .then((rs) => {
          console.log(rs);
          if (rs.data[0].Code == "Ok") {
            this.$notify({
              title: "发送成功",
              message: `短信发送成功${rs.data[0].Message}`,
              type: "success",
            });
          }

          //添加短信发送时间，先判断是否有发送过，如果没有，直接往数据库里添加，如果有发送过，再次点击时更新数据
          this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("sendsms").where({piaos:"${pnum}"}).get()`,
            })
            .then((ee) => {
              ee.data.data.forEach((element, index, array) => {
                array[index] = JSON.parse(element);
              });
              if (ee.data.data.length !== 0) {
                return this.axios.post(
                  "/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN,
                  {
                    env: `${this.userData.env}`,
                    query: `db.collection("sendsms").doc("${
                      ee.data.data[0]._id
                    }").update({data:{sendtime:"${dayjs().format(
                      "YYYY-MM-DD HH:mm:ss"
                    )}"}})`,
                  }
                );
              }
              //添加数据
              this.axios.post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query: `db.collection("sendsms").add({data:{sendtime:"${dayjs().format(
                  "YYYY-MM-DD HH:mm:ss"
                )}",piaos:"${pnum}"}})`,
              });
            });
        });
    },

    //上传续当凭证
    UpLoading(event) {
      this.dialogUploading = !this.dialogUploading;
      this.pzid = event._id;
      this.pzImg = event.imags;
      this.pzImgs = event.imag; //当票

      if (
        event.imags ==
        "https://6368-changan2020-qtz0s-1302496284.tcb.qcloud.la/images/jkjk.jpg"
      ) {
        this.dpIsshow = true;
      } else {
        this.dpIsshow = false;
      }
    },
    //查看凭证
    WacthdP() {
      this.isSHowImg = !this.isSHowImg;
    },

    //点击确认上传
    dialogUploadings() {
      if (this.dp == "" && this.pz !== "") {
        //如果当票上传为空，凭证上传不为空，则上传凭证
        this.axios
          .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("add_data").doc("${this.pzid}").update({data:{imag:"${this.pz}"}})`,
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              //上传成功
              this.$notify({
                title: "上传成功",
                message: "续当凭证上传成功",
                type: "success",
              });

              setTimeout(() => {
                this.$router.go(0);
              }, 800);
            }
          });
      } else if (this.pz == "" && this.dp !== "") {
        //如果凭证为空，当票不为空则上传当票
        this.axios
          .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("add_data").doc("${this.pzid}").update({data:{imags:"${this.dp}"}})`,
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              //上传成功
              this.$notify({
                title: "上传成功",
                message: "当票上传成功",
                type: "success",
              });
              setTimeout(() => {
                this.$router.go(0);
              }, 800);
            }
          });
      } else if (this.pz !== "" && this.dp !== "") {
        //如果当票和凭证都不为空，则都上传
        this.axios
          .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("add_data").doc("${this.pzid}").update({data:{imags:"${this.dp}",imag:"${this.pz}"}})`,
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              //上传成功
              this.$notify({
                title: "上传成功",
                message: "当票和续当凭证上传成功",
                type: "success",
              });
              setTimeout(() => {
                this.$router.go(0);
              }, 800);
            }
          });
      } else {
        //如果条件都不符合那么则弹窗提示
        this.$notify.error({
          title: "提交错误",
          message: "请先上传凭证后在提交",
        });
      }
    },
    //关闭上传凭证弹窗
    dialogUploadingClose() {
      this.dialogUploading = false;
      this.pzid = "";
      this.pz = "";
      this.dp = "";
      this.dpIsshow = true;
    },

    //上传凭证事件
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file) {
      this.$confirm(`确定移除 ${file.name}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          cos
            .deleteObject({
              Bucket: "changan-1259114000" /* 填入您自己的存储桶，必须字段 */,
              Region: "ap-guangzhou" /* 存储桶所在地域，例如ap-beijing，必须字段 */,
              Key:
                file.name /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
            })
            .then(() => {
              this.$message({
                showClose: true,
                message: "文件删除成功",
                type: "success",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //上传方法
    uploads(res) {
      if (res.file) {
        // 执行上传操作
        cos.putObject(
          {
            Bucket: "changan-1259114000" /* 存储桶 */,
            Region: "ap-guangzhou" /* 存储桶所在地域，必须字段 */,
            Key: res.file.name /* 文件名 */,
            StorageClass: "STANDARD", // 上传模式, 标准模式
            Body: res.file, // 上传文件对象
          },
          (err, data) => {
            // 上传成功之后
            if (data.statusCode == 200) {
              this[res.data.isName] = "https://" + data.Location;
            }
          }
        );
      }
    },

    //修改当票
    UploadWatch() {
      this.dpIsshow = true;
    },

    //查看凭证
    ViewPz() {
      this.pzIsShows = !this.pzIsShows;
    },

    //生成通知文本
    CreateText(event) {
      this.dialogText = !this.dialogText;
      this.DialogTextData = event;

      this.getLastTimeData(event.ticketnumber);
    },
    //请求上期的典当天数
    getLastTimeData(event) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").where({ticketnumber:"${event}"}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          let newDateFilter = res.data.data.filter((item) => {
            return item.stas == "续当";
          });

          newDateFilter.sort(function (a, b) {
            return (
              new Date(b.xuday.replace(/-/g, "/")).getTime() -
              new Date(a.xuday.replace(/-/g, "/")).getTime()
            );
          });
          this.newArray = newDateFilter[0];
        });
    },

    //关闭通知文本
    handleCloseText() {
      this.dialogText = false;
      this.DialogTextData = "";
      this.newArray = "";
    },

    //关闭待办通知
    handleCloseBacklog() {
      this.dialogBacklog = false;
    },
    //请求今天的待办事项
    getBacklog() {
      //绝当待确认
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("add_data").where({state:"在当",enddate:_.lt("${this.day}")}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          if (res.data.pager.Total > 0) {
            this.dialogBacklog = true;
            this.BacklogData = res.data.pager.Total;
          }
        });
    },

    //请求全部在当数据
    getAll() {
      if (this.allItems.length == 0) {
        return this.$alert(
          "没有数据可以导出，请先点击ALL请求数据，再来导出吧！！",
          "温馨提示",
          {
            confirmButtonText: "确定",
          }
        );
      }
    },
    GetAllData() {
      this.dialogGetAll = true;
      let N = 30;
      this.AllDataIndex = N + Math.floor(Math.random() * 10);

      this.axios
        .post("/api/tcb/databasecount?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").where({state:"在当",enddate:_.gte("' +
            this.day +
            '"),whether:true}).count()',
        })
        .then((res) => {
          let num = Math.ceil(res.data.count / 1000);
          let newArr = [];

          for (let i = 0; i < num; i++) {
            // let indexs = i * 1000;

            this.axios
              .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query: `db.collection("add_data").where({state:"在当",enddate:_.gte("${
                  this.day
                } "),whether:true}).limit(1000).skip(${i * 1000}).get()`,
              })
              .then((rec) => {
                rec.data.data.forEach((element, index, array) => {
                  array[index] = JSON.parse(element);
                });

                newArr.push(...rec.data.data);
              })
              .then(() => {
                this.allItems = newArr;
                this.AllDataIndex = 100;
                setTimeout(() => {
                  this.dialogGetAll = false;
                }, 1000);
              });
          }
        });
    },
    //清除请求全部数据进度
    removeAllData() {
      this.AllDataIndex = 0;
      this.dialogGetAll = false;
    },
    //续当弹窗计算开始日期
    computDate(event, lastDate) {
      return dayjs(event).subtract(lastDate, "day").format("YYYY-MM-DD");
    },

    //上传录音文件
    UploadRecord(event) {
      console.log(event);
    },

    //打印告知书
    PrintText(event) {
      console.log(event);
      this.PrintTextDiglog = !this.PrintTextDiglog;
      this.NewDatas = event;
    },
    //关闭打印
    PrintTextDiglogClose() {
      this.PrintTextDiglog = false;
      this.NewDatas = {};
    },
  },

  created() {
    this.deta = dayjs().format("YYYY-MM-DD");

    //逾期、绝当鉴定日期
    this.day = dayjs().subtract(5, "day").format("YYYY-MM-DD");

    new Promise((resovle, reject) => {
      //获取到this.ACCESS_TOKEN
      // resovle(
      this.getTokens();
      //获取当前登录的用户数据
      this.getUserToken();
      setTimeout(() => {
        if (this.userData.username !== undefined && this.ACCESS_TOKEN !== undefined) {
          resovle();
        } else {
          reject();
        }
      }, 800);
      // )
    }).then(() => {
      //请求总在当数据的数量
      this.axios
        .post("/api/tcb/databasecount?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").where({state:"在当",enddate:_.gte("' +
            this.day +
            '"),whether:true}).count()',
        })
        .then((ilength) => {
          if (ilength.data.errcode !== 0) {
            return this.$notify.error({
              title: "错误提示",
              message: "密钥过期啦，请刷新页面",
            });
          }
          this.ilength = parseInt(ilength.data.count);
          this.yelength = parseInt(ilength.data.count);

          //拿到在当订单的总数除以每次请求1000条，向上取整，拿到要求的次数
          let counts = Math.ceil(parseInt(ilength.data.count) / 1000);

          // let ns = 0
          for (let i = 0; i < counts; i++) {
            let num = i * 1000;

            this.axios
              .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query:
                  'db.collection("add_data").where({state:"在当",enddate:_.gte("' +
                  this.day +
                  '"),whether:true}).limit(1000).skip(' +
                  num +
                  ").get()",
              })
              .then((rd) => {
                rd.data.data.forEach((element, index, array) => {
                  array[index] = JSON.parse(element);
                });

                //循环计算典当的总金额
                let str = "";

                for (let i in rd.data.data) {
                  //第一栏总金额
                  str += rd.data.data[i].price;
                  str += "+";
                  //第二栏总金额（如有）

                  //第三栏总金额（如有）
                }
                str = str.substring(0, str.length - 1);
                this.totalarray.push(eval(str));

                //第一次循环拿到多次循环出来的金额

                //第二次循环把多次循环的结果进行循环相加拿到总金额

                let ae = 0;
                for (let x in this.totalarray) {
                  ae += this.totalarray[x];
                }
                this.zpri = ae;
                this.zpriClick = ae;
              });
          }
        }),
        //请求今天新增加的数量
        this.axios
          .post("/api/tcb/databasecount?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("add_data").where({state:"在当",reviewdate:_.eq("' +
              this.deta +
              '")}).count()',
          })
          .then((xzlength) => {
            this.xzlength = xzlength.data.count;
          }),
        //请求今天新增的总金额
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("add_data").where({state:"在当",reviewdate:_.eq("' +
              this.deta +
              '")}).get()',
          })
          .then((xzpri) => {
            xzpri.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            //循环计算新增典当的总金额
            let str = "";
            for (let i in xzpri.data.data) {
              str += xzpri.data.data[i].price;
              str += "+";
            }
            str = str.substring(0, str.length - 1);
            this.xzpri = eval(str) || 0;
          }),
        this.getzdata(),
        // this.getusername() //获取用户的名字
        (this.name = this.userData.username);
      this.titles = this.userData.title;
    });
  },

  mounted() {
    //请求待办事项
    setTimeout(() => {
      this.getBacklog();
    }, 800);

    // setTimeout(()=>{
    //   //请求总在当数据的数量
    //      this.axios
    //         .post("/api/tcb/databasecount?access_token=" + this.ACCESS_TOKEN, {
    //           env: `${this.userData.env}`,
    //           query:
    //             'db.collection("add_data").where({state:"在当",enddate:_.gte("' +
    //             this.day +
    //             '"),whether:true}).count()',
    //         })
    //         .then((ilength) => {
    //           if(ilength.data.errcode !== 0){
    //             return this.$notify.error({
    //                 title: '错误提示',
    //                 message: '密钥过期啦，请刷新页面'
    //               });
    //           }
    //           this.ilength = parseInt(ilength.data.count);
    //           this.yelength = parseInt(ilength.data.count);
    //           //拿到在当订单的总数除以每次请求1000条，向上取整，拿到要求的次数
    //           let counts = Math.ceil(parseInt(ilength.data.count) / 1000)
    //           // let ns = 0
    //           for(let i=0; i <counts; i++){
    //             let num = i*1000
    //             this.axios
    //               .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
    //                 env: `${this.userData.env}`,
    //                 query:
    //                   'db.collection("add_data").where({state:"在当",enddate:_.gte("' +
    //                   this.day +
    //                   '"),whether:true}).limit(1000).skip('+num+').get()',
    //               })
    //               .then(rd=>{
    //                 rd.data.data.forEach((element, index, array) => {
    //                   array[index] = JSON.parse(element);
    //                 });
    //                     //循环计算新增典当的总金额
    //                 let str = "";
    //                 for (let i in rd.data.data) {
    //                   str += rd.data.data[i].price;
    //                   str += "+";
    //                 }
    //                 str = str.substring(0, str.length - 1);
    //                 this.totalarray.push(eval(str))
    //                 //第一次循环拿到多次循环出来的金额
    //                 //第二次循环把多次循环的结果进行循环相加拿到总金额
    //                 let ae = 0
    //                 for(let x in this.totalarray){
    //                   ae += this.totalarray[x]
    //                 }
    //                   this.zpri = ae;
    //                   this.zpriClick = ae
    //               })
    //           }
    //         }),
    //       //请求今天新增加的数量
    //       this.axios
    //         .post("/api/tcb/databasecount?access_token=" + this.ACCESS_TOKEN, {
    //           env: `${this.userData.env}`,
    //           query:
    //             'db.collection("add_data").where({state:"在当",reviewdate:_.eq("' +
    //             this.deta +
    //             '")}).count()',
    //         })
    //         .then((xzlength) => {
    //           this.xzlength = xzlength.data.count;
    //         }),
    //       //请求今天新增的总金额
    //       this.axios
    //         .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
    //           env: `${this.userData.env}`,
    //           query:
    //             'db.collection("add_data").where({state:"在当",reviewdate:_.eq("' +
    //             this.deta +
    //             '")}).get()',
    //         })
    //         .then((xzpri) => {
    //           xzpri.data.data.forEach((element, index, array) => {
    //             array[index] = JSON.parse(element);
    //           });
    //           //循环计算新增典当的总金额
    //           let str = "";
    //           for (let i in xzpri.data.data) {
    //             str += xzpri.data.data[i].price;
    //             str += "+";
    //           }
    //           str = str.substring(0, str.length - 1);
    //           this.xzpri = eval(str) || 0;
    //         }),
    //       this.getzdata(),
    //     // this.getusername() //获取用户的名字
    //     this.name = this.userData.username
    //     this.titles = this.userData.title
    // },800)
  },

  /*

          开发须知：

        █▀▀▀▀▀▀▀█▀██████▀█▀▀█████▀▀█▀█▀▀███▀▀▀▀▀▀▀█
        █ █▀▀▀█ █  █  ▀█ █▄████▄ ▄   █▄ ▀▄█ █▀▀▀█ █
        █ █   █ █▄▀▄▄ █ ▄█▄ ▀  ▄ █▄ ▄██▀▄ █ █   █ █
        █ ▀▀▀▀▀ █ ▄▀▄▀▄ █ █▀▄▀▄ ▄▀█ ▄ █▀█ █ ▀▀▀▀▀ █
        █▀▀██▀▀▀██▀▀█▄ ▀▄▄▀ ▀█▀ ▄█▄ ██▀ ▀ ██▀█▀▀▀▀█
        █▀ ▀▄▀█▀ █ ▀█▀▄▄▄ ▀▄▀▄▄██ ▄▀▄ ██▀ ▀███ ▄▀▄█
        █   ▀█▄▀▀██▀▄▀▀  █▄ ▀▀▀▄▄ ▄ ▄▀▀▄   ▀█▀ ▄█ █
        █ ▀█ ▄█▀▄ ▄ ███▀█ ▀▀ █▀▄█▄ ▀▄▀█ ▀█▀▄▀█ ▄▀██
        █▀█▀▀▀ ▀▄▄█ ▀ ▄▄▀█▀ ▄▄▀██ ▄█ ▄▀ █ ▄▀▄▄█▄ ██
        █▀▀ █▀▄▀ ▀█ ▄█▀ █▀▄▀▀ ▄ ▄█▄▄███▀ ▄▄▀ ▀█ █▄█
        ███ ▀▀█▀▀ █  █ █ ▀██▀▄▀▀█ ▄▀▀▄▀ █▀█ ▀▄█ ▀▀█
        █ █ ▀█ ▀██▀▀▀ █▄▀█  ▄  █▄▄▀▀▄▄▀▄ ▄██▀█▀▄▀▄█
        ██▀▀▄▀▀▀▀ ▀ ▄▀▄▀▄ ▀▄▀▀█▄ █▄  ▀▀▄█ ▀▀▀▀ ▄▄ █
        █▄█   ▀▀▄▄▀ ▄▄▄▄▄█▀▄▀▀▀▄▄▄▄█▄█▀▄▀▀█ ▀▀█  ██
        █▄▀▀█  ▀▄▄▀   ▀ ▀█▄ ▀ ██▄ ▄▄█▀█▀█▄▄▀▄██▄ ▀█
        █▄█  ▄▄▀██▄▄██ ▀█ ▀▀ █▀█▄▀█ ▄█▀ ▀  █ ▀ ██▄█
        █▀▀ ▄ █▀▀ █ ▀▄ ▀▀█▀▀▄ ▀▀   ▀█▄█ ▄    ▀█ ▀▀█
        █▀▀▀▀▀▀▀█▄ ▄█ ▀ ▄ ▄▀▀ ▄▀█ ▄ ▄▄▀▄▀ █▀█ ▄▄▀██
        █ █▀▀▀█ █   ▄▄ ██▀██▀ ▀▄█ ▄▀ ▄▀▄█ ▀▀▀  ▄▀▄█
        █ █   █ ██ ▄▀ ▄▄▀█▄▄▄▄▀██▄█▀█▀█ ██▀ ▀▀▀██ █
        █ ▀▀▀▀▀ █ ▄ ▄▀▄▄▄▄█▀█▀██ ▀▄█  █▀█▄ █▀▀▀▄ ▄█
        ▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀


  */
};
</script>
<style scoped>
.cont_header {
  width: 40%;
  height: 158px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.cont_o {
  width: 45%;
  height: 110px;
  background-color: #62cf2f;
  border-radius: 10px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.cont_o h3 {
  margin: 0 0;
}
.cont_tabs {
  margin: 20px auto;
}
/*今日新增样式*/
.el-table >>> .today-row {
  background: #9fe079cb;
}
/* 快绝当样式 */
.el-table >>> .warning-row {
  background: #fa9393;
}
/* 逾期样式 */
.el-table >>> .success-row {
  background: #ccc22d;
}
/* 今天到期的业务 */
.el-table >>> .tod-row {
  background: #a2b6d4;
}
.ces {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  /* justify-content: flex-end; */
  justify-content: space-evenly;
  align-items: center;
  border-radius: 8px;
}
.blue {
  border-style: solid;
  border-width: medium;
  color: #90e95c;
  margin: 0 20px;
}
.yus {
  border-style: solid;
  border-width: medium;
  color: #ccc22d;
  margin: 0 20px;
}
.jus {
  border-style: solid;
  border-width: medium;
  color: #fa9393;
  margin-right: 60px;
}
.zxs {
  color: #e99ef0;
}
.cont_input {
  width: 25%;
}
.color_text {
  color: #2c2c2c;
}
.fs {
  margin: 15px auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.black {
  border-style: solid;
  border-width: medium;
  /* background-color: #9e9e9e; */
}
.blues {
  border-style: solid;
  border-width: medium;
  margin: 0 10px;
  color: #a2b6d4;
}
.con_query {
  width: 59%;
  height: 160px;
  background-color: #ffffff;
}
.ce {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

/* 打印的样式 */
#print_demo {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.cers {
  display: flex;
  flex-direction: column;
}
.cers span {
  margin: 2px 0;
  font-size: 5px;
}
.ss {
  display: flex;
  flex-direction: column;
  margin: 0 30px;
}
.ss span {
  margin: 2px 0;
  font-size: 5px;
}
.cont {
  display: flex;
  flex-direction: row;
}
.contleft {
  width: 65%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 50px;
  font-size: 5px;
}
.contrig {
  width: 35%;
  margin-top: 50px;
  font-size: 5px;
}

/* 打印样式表格 */
table {
  border-collapse: collapse;
}
th,
td {
  /* width: 100%; */
  height: 20px;
  /* border: 1px solid black; */
  font-size: 12px;
  text-align: center;
}
td input {
  outline: none;
  border: 0;
  height: 100%;
  width: 11px;
  background-color: #a5a5a5;
}
.fl {
  padding: 0 0;
}
td span input {
  background-color: #2c2c2c;
}
.ctens {
  display: flex;
  flex-direction: column;
}
.ctens span {
  margin: 12px 0;
}
.sum_pri {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.sum_pri span {
  width: 10px;
  margin: 0 5px;
}
/* .sum_pribox{
  margin: 0 5px;
} */
.sum_pribox {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.watchPiao {
  display: flex;
  flex-direction: row;
}
.upload_xg {
  margin: 0 10px;
}
.btn_xu {
  color: #2c2c2c;
  font-size: 16px;
  font-weight: bold;
}
.footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.dialogs_fd {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
